/**
 * Recover from stale lazy chunks after a deploy.
 *
 * Every `vite build` emits route chunks with new content hashes and the PWA
 * service worker purges the previous precache, so a tab that still runs the
 * old app shell fails its next `import()` with "Failed to fetch dynamically
 * imported module". Vite reports that as a `vite:preloadError` event on
 * `window`; we reload once so the fresh shell (and its chunk names) takes over.
 *
 * A sessionStorage flag guards against a reload loop if the reload itself
 * still lands on a stale shell; the flag is consumed on the next failure so a
 * later deploy can recover again.
 */
export const RELOAD_FLAG = "alzadrach:chunk-reloaded";

export function installChunkReload(win: Window = window): void {
  win.addEventListener("vite:preloadError", (event) => {
    let alreadyReloaded = false;
    try {
      alreadyReloaded = win.sessionStorage.getItem(RELOAD_FLAG) !== null;
      if (alreadyReloaded) {
        win.sessionStorage.removeItem(RELOAD_FLAG);
      } else {
        win.sessionStorage.setItem(RELOAD_FLAG, "1");
      }
    } catch {
      // sessionStorage unavailable (private mode): still reload once per event.
    }
    if (alreadyReloaded) return;
    event.preventDefault();
    win.location.reload();
  });
}
